<template>
  <v-container fluid style="padding: 0; min-height: 100vh">
    <v-row no-gutters>
      <v-col cols="12">
        <GlobalNav></GlobalNav>
      </v-col>
      <v-col cols="12">
        <div class="d-flex h-100">
          <SideBar></SideBar>
          <div class="pa-5 w-100">
            <BreadCrumb :linksData="linksData" class="mb-5" />
            <div class="leads-managements-link d-flex align-center ga-2 my-3">
              <div
                @click="$router.push({ name: 'integrations' })"
                class="link cursor-pointer hoverd-style-line d-flex align-center ga-2"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825Z"
                    fill="#1F666A"
                  />
                </svg>
                <span>Integrations</span>
              </div>
            </div>
            <div class="d-flex ga-2 align-center">
              <div class="page-image">
                <img
                  width="68"
                  height="68"
                  class="rounded-circle"
                  src="https://s3-alpha-sig.figma.com/img/e4a2/5cd3/cee97fa96562ade6511f633af5ffe684?Expires=1738540800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=EE91eWDrbooe2dnG9qhwf8yalyKgOqp3SfIgtzjw3x-HpgE4hM5P0jbnDwzaM8wSXXyWfNuOYvLuzlXvtXf37Hew~mWNuzfMNd-wRWJT5DtqjYqLxTyuIcb2tYsT8VKfEOq0WYTFsNSyvfFmrr3ecOQrqr12uW-QsR6PyalZHYb4w-~~f71DCJgQoPU4N5QsIeomN1d1mt16phBHTdemkeqx5CW8IGTQ1OCff~8z0F5fiWDhbKnTXBW2g~zu7bbKhOZG8RivpdtgQBjYFa2YmHEW6hFAa24Md-UZlFLaHFPVF6N8VgetRFUyiQsVtx1HJ4e2EV8cEoKYXmc4gq81tg__"
                  alt=""
                />
              </div>
              <div class="page-data d-flex flex-column ga-2">
                <span class="f-s-20 c-dark f-w-600">Qareacompany</span>
                <div class="d-flex ga-3 align-center">
                  <div class="d-flex align-center ga-2">
                    <span class="f-s-16 c-dark f-w-600">60K</span>
                    <span class="f-s-14 c-dark f-w-400">Followers</span>
                  </div>
                  <div class="d-flex align-center ga-2">
                    <span class="f-s-16 c-dark f-w-600">4</span>
                    <span class="f-s-14 c-dark f-w-400">Following</span>
                  </div>
                  <div class="d-flex align-center ga-2">
                    <span class="f-s-16 c-dark f-w-600">1.234</span>
                    <span class="f-s-14 c-dark f-w-400">Posts</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-5">
              <v-row>
                <v-col cols="12">
                  <v-sheet class="pa-5 ma-2 border rounded-lg">
                    <div class="f-s-20 c-dark f-w-600">Last 24 hours</div>
                    <v-row>
                      <v-col cols="6" :lg="3">
                        <v-sheet class="pa-2 ma-2 d-flex align-center ga-3">
                          <span>
                            <svg
                              width="42"
                              height="43"
                              viewBox="0 0 42 43"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <ellipse
                                cx="20.7571"
                                cy="21.1088"
                                rx="20.7571"
                                ry="21.058"
                                fill="#DDECED"
                                fill-opacity="0.4"
                              />
                              <g clip-path="url(#clip0_5445_123153)">
                                <path
                                  d="M24.6875 28.1133H20.9318L24.8777 22.7977C25.6733 21.737 26.0938 20.4738 26.0938 19.1445C26.0938 15.7844 23.3601 13.0508 20 13.0508C16.6399 13.0508 13.9062 15.7844 13.9062 19.1445C13.9062 20.4738 14.3268 21.737 15.1209 22.7959L19.0683 28.1133H15.3125C15.0536 28.1133 14.8438 28.3232 14.8438 28.582C14.8438 28.8409 15.0536 29.0508 15.3125 29.0508H24.6875C24.9464 29.0508 25.1562 28.8409 25.1562 28.582C25.1562 28.3232 24.9464 28.1133 24.6875 28.1133ZM15.8723 22.2352C15.1994 21.3381 14.8438 20.2693 14.8438 19.1445C14.8438 16.3014 17.1568 13.9883 20 13.9883C22.8432 13.9883 25.1562 16.3014 25.1562 19.1445C25.1562 20.2693 24.8006 21.3381 24.1264 22.2371L20 27.7956L15.8723 22.2352Z"
                                  fill="#237276"
                                />
                                <path
                                  d="M20 14.9258C17.6738 14.9258 15.7812 16.8183 15.7812 19.1445C15.7812 21.4736 17.6774 23.3633 20 23.3633C22.3144 23.3633 24.2188 21.4821 24.2188 19.1445C24.2188 16.8183 22.3262 14.9258 20 14.9258ZM20 22.4258C19.3372 22.4258 18.7199 22.2281 18.2034 21.8888C18.4369 21.1098 19.166 20.5508 20 20.5508C20.834 20.5508 21.5631 21.1098 21.7966 21.8888C21.2801 22.2281 20.6628 22.4258 20 22.4258ZM19.0625 18.6758C19.0625 18.1588 19.4831 17.7383 20 17.7383C20.5169 17.7383 20.9375 18.1588 20.9375 18.6758C20.9375 19.1927 20.5169 19.6133 20 19.6133C19.4831 19.6133 19.0625 19.1927 19.0625 18.6758ZM22.5403 21.219C22.2963 20.7062 21.8948 20.2599 21.3601 19.9644C21.6788 19.6282 21.875 19.1746 21.875 18.6758C21.875 17.6419 21.0339 16.8008 20 16.8008C18.9661 16.8008 18.125 17.6419 18.125 18.6758C18.125 19.1746 18.3212 19.6282 18.6399 19.9644C18.1056 20.2597 17.7038 20.7058 17.4597 21.219C16.9968 20.6533 16.7188 19.9308 16.7188 19.1445C16.7188 17.3352 18.1907 15.8633 20 15.8633C21.8093 15.8633 23.2812 17.3352 23.2812 19.1445C23.2812 19.9308 23.0032 20.6533 22.5403 21.219Z"
                                  fill="#237276"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_5445_123153">
                                  <rect
                                    width="16"
                                    height="16"
                                    fill="white"
                                    transform="translate(12 13.0508)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </span>
                          <span class="d-flex ga-1 flex-column">
                            <span class="f-s-16 c-dark f-w-600">100,000</span>
                            <span class="f-s-14 c-gray f-w-400"
                              >Channel visits</span
                            >
                          </span>
                        </v-sheet>
                      </v-col>
                      <v-col cols="6" :lg="3">
                        <v-sheet class="pa-2 ma-2 d-flex align-center ga-3">
                          <span>
                            <svg
                              width="42"
                              height="43"
                              viewBox="0 0 42 43"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <ellipse
                                cx="21.0071"
                                cy="21.1088"
                                rx="20.7571"
                                ry="21.058"
                                fill="#DDECED"
                                fill-opacity="0.4"
                              />
                              <path
                                d="M10.5588 13.0508H29.7062H30.348V13.6926V29.409V30.0508H29.7062H10.5588H9.91699V29.409V13.6926V13.0508H10.5588ZM29.0644 14.3344H11.2006V28.7672H29.0644V14.3344Z"
                                fill="#237276"
                              />
                              <path
                                d="M10.5588 17.3789H29.7062H30.348V18.0207V29.4089V30.0507H29.7062H10.5588H9.91699V29.4089V18.0207V17.3789H10.5588ZM29.0644 18.6625H11.2006V28.7671H29.0644V18.6625Z"
                                fill="#237276"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M12.2686 15.2148H13.5522V16.4985H12.2686V15.2148Z"
                                fill="#237276"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M14.7324 15.2148H16.016V16.4985H14.7324V15.2148Z"
                                fill="#237276"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M17.1953 15.2148H18.4789V16.4985H17.1953V15.2148Z"
                                fill="#237276"
                              />
                              <path
                                d="M23.4805 23.7131C22.6712 22.7754 20.1861 20.5459 16.8726 23.7131C20.1861 26.8802 22.6712 24.6508 23.4805 23.7131ZM15.5048 23.2768C20.9008 17.4682 24.8095 23.3354 24.8209 23.3521L25.0675 23.7131L24.8209 24.0741C24.8095 24.0908 20.9007 29.9579 15.5048 24.1493L15.0996 23.7131L15.5048 23.2768Z"
                                fill="#237276"
                              />
                              <path
                                d="M20.1311 24.3578C20.4855 24.3578 20.7729 24.0705 20.7729 23.716C20.7729 23.3616 20.4855 23.0742 20.1311 23.0742C19.7766 23.0742 19.4893 23.3616 19.4893 23.716C19.4893 24.0705 19.7766 24.3578 20.1311 24.3578Z"
                                fill="#237276"
                              />
                            </svg>
                          </span>
                          <span class="d-flex ga-1 flex-column">
                            <span class="f-s-16 c-dark f-w-600">100,000</span>
                            <span class="f-s-14 c-gray f-w-400"
                              >Videos Views</span
                            >
                          </span>
                        </v-sheet>
                      </v-col>
                      <v-col cols="6" :lg="3">
                        <v-sheet class="pa-2 ma-2 d-flex align-center ga-3">
                          <span>
                            <svg
                              width="43"
                              height="43"
                              viewBox="0 0 43 43"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <ellipse
                                cx="21.2571"
                                cy="21.1088"
                                rx="20.7571"
                                ry="21.058"
                                fill="#DDECED"
                                fill-opacity="0.4"
                              />
                              <path
                                d="M25.9759 29.0508H20.4517C18.6229 29.0508 18.0259 28.637 17.0436 27.62C16.9814 27.5615 16.9317 27.4909 16.8975 27.4126C16.8633 27.3343 16.8454 27.2499 16.8447 27.1645C16.8441 27.079 16.8608 26.9944 16.8939 26.9156C16.9269 26.8368 16.9756 26.7655 17.0369 26.7061C17.0983 26.6466 17.1711 26.6003 17.2509 26.5698C17.3307 26.5393 17.4158 26.5253 17.5012 26.5286C17.5866 26.532 17.6704 26.5526 17.7475 26.5893C17.8247 26.6259 17.8936 26.6779 17.9501 26.7419C18.6861 27.5031 18.964 27.7874 20.4517 27.7874H25.9759C26.2446 27.7874 26.5047 27.6923 26.7099 27.5188C26.9152 27.3453 27.0523 27.1048 27.0971 26.8398L27.9278 22.2884C27.9547 22.1682 28.0162 22.0584 28.1047 21.9726C28.7364 21.3409 28.9417 20.6934 28.6985 20.1028C28.6101 19.8756 28.4613 19.6769 28.2681 19.5283C28.0749 19.3796 27.8447 19.2867 27.6025 19.2594H24.7598C24.6677 19.2606 24.5763 19.2416 24.4923 19.2038C24.4082 19.1659 24.3334 19.1101 24.2732 19.0403C24.213 18.9704 24.1689 18.8883 24.1438 18.7995C24.1187 18.7108 24.1134 18.6177 24.1282 18.5267C24.1282 18.5077 24.4187 16.7421 24.1282 15.624C23.9355 14.8502 23.6196 14.3606 23.3069 14.329C23.2162 14.3296 23.1269 14.352 23.0467 14.3943C22.9664 14.4366 22.8975 14.4977 22.8458 14.5722C22.8458 15.2829 22.8111 17.0296 21.3961 18.4446C19.981 19.8596 17.6753 20.1849 17.5838 20.1975C17.5008 20.2091 17.4164 20.2043 17.3353 20.1833C17.2542 20.1623 17.178 20.1255 17.1112 20.075C17.0443 20.0246 16.988 19.9615 16.9455 19.8893C16.9031 19.8171 16.8752 19.7372 16.8636 19.6543C16.852 19.5713 16.8568 19.4869 16.8779 19.4058C16.8989 19.3247 16.9357 19.2485 16.9861 19.1817C17.0365 19.1148 17.0997 19.0585 17.1719 19.0161C17.2441 18.9736 17.3239 18.9457 17.4069 18.9341C17.4448 18.9341 19.4346 18.6183 20.5243 17.5349C21.614 16.4515 21.6014 15.0902 21.6014 14.5059C21.6014 13.8363 22.3025 13.1604 23.0985 13.0625C23.5975 13.0025 24.8199 13.0941 25.3726 15.3019C25.5473 16.1837 25.5814 17.0877 25.4737 17.9803H27.6025C28.0941 18.0087 28.5676 18.1761 28.9679 18.4629C29.3682 18.7497 29.6789 19.1442 29.864 19.6006C30.2872 20.6208 30.0187 21.7389 29.1375 22.7022L28.3416 27.0799C28.2403 27.6333 27.948 28.1337 27.5158 28.4939C27.0835 28.854 26.5385 29.0511 25.9759 29.0508Z"
                                fill="#237276"
                              />
                              <path
                                d="M17.4953 28.979H14.1346C13.9671 28.979 13.8064 28.9124 13.6879 28.794C13.5695 28.6755 13.5029 28.5148 13.5029 28.3473V18.8465C13.5029 18.679 13.5695 18.5183 13.6879 18.3999C13.8064 18.2814 13.9671 18.2148 14.1346 18.2148H17.4953C17.6628 18.2148 17.8235 18.2814 17.9419 18.3999C18.0604 18.5183 18.127 18.679 18.127 18.8465V28.3473C18.127 28.5148 18.0604 28.6755 17.9419 28.794C17.8235 28.9124 17.6628 28.979 17.4953 28.979ZM14.7663 27.7156H16.8636V19.4782H14.7663V27.7156Z"
                                fill="#237276"
                              />
                            </svg>
                          </span>
                          <span class="d-flex ga-1 flex-column">
                            <span class="f-s-16 c-dark f-w-600">100,000</span>
                            <span class="f-s-14 c-gray f-w-400"
                              >Videos likes</span
                            >
                          </span>
                        </v-sheet>
                      </v-col>
                      <v-col cols="6" :lg="3">
                        <v-sheet class="pa-2 ma-2 d-flex align-center ga-3">
                          <span>
                            <svg
                              width="43"
                              height="43"
                              viewBox="0 0 43 43"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <ellipse
                                cx="21.5071"
                                cy="21.1088"
                                rx="20.7571"
                                ry="21.058"
                                fill="#DDECED"
                                fill-opacity="0.4"
                              />
                              <path
                                d="M26.4729 13.0508H20.9487C19.12 13.0508 18.523 13.4645 17.5407 14.4816C17.4785 14.5401 17.4288 14.6107 17.3946 14.6889C17.3604 14.7672 17.3424 14.8517 17.3418 14.9371C17.3412 15.0225 17.3579 15.1072 17.3909 15.186C17.424 15.2648 17.4726 15.336 17.534 15.3955C17.5954 15.4549 17.6681 15.5013 17.7479 15.5318C17.8277 15.5623 17.9129 15.5763 17.9983 15.573C18.0836 15.5696 18.1674 15.549 18.2446 15.5123C18.3218 15.4756 18.3907 15.4237 18.4472 15.3596C19.1831 14.5984 19.4611 14.3142 20.9487 14.3142H26.4729C26.7417 14.3142 27.0017 14.4093 27.207 14.5828C27.4122 14.7562 27.5494 14.9968 27.5942 15.2617L28.4249 19.8131C28.4518 19.9334 28.5133 20.0432 28.6018 20.129C29.2335 20.7607 29.4388 21.4082 29.1956 21.9988C29.1072 22.226 28.9583 22.4246 28.7652 22.5733C28.572 22.7219 28.3418 22.8149 28.0996 22.8421H25.2569C25.1647 22.8409 25.0734 22.8599 24.9893 22.8978C24.9053 22.9357 24.8305 22.9915 24.7703 23.0613C24.7101 23.1311 24.6659 23.2133 24.6409 23.302C24.6158 23.3907 24.6105 23.4839 24.6252 23.5749C24.6252 23.5938 24.9158 25.3594 24.6252 26.4775C24.4326 27.2514 24.1167 27.7409 23.804 27.7725C23.7133 27.772 23.624 27.7496 23.5437 27.7072C23.4635 27.6649 23.3946 27.6039 23.3429 27.5293C23.3429 26.8187 23.3081 25.072 21.8931 23.657C20.4781 22.242 18.1724 21.9167 18.0808 21.904C17.9979 21.8924 17.9134 21.8973 17.8323 21.9183C17.7513 21.9393 17.6751 21.9761 17.6082 22.0265C17.5414 22.077 17.4851 22.1401 17.4426 22.2123C17.4001 22.2845 17.3723 22.3643 17.3607 22.4473C17.3491 22.5303 17.3539 22.6147 17.3749 22.6958C17.3959 22.7769 17.4327 22.853 17.4832 22.9199C17.5336 22.9868 17.5967 23.043 17.6689 23.0855C17.7411 23.128 17.821 23.1558 17.9039 23.1674C17.9418 23.1674 19.9317 23.4833 21.0214 24.5667C22.1111 25.65 22.0984 27.0113 22.0984 27.5956C22.0984 28.2652 22.7996 28.9412 23.5956 29.0391C24.0946 29.0991 25.3169 29.0075 25.8697 26.7997C26.0443 25.9178 26.0784 25.0139 25.9707 24.1213H28.0996C28.5912 24.0928 29.0647 23.9255 29.465 23.6387C29.8653 23.3519 30.176 22.9574 30.361 22.501C30.7843 21.4808 30.5158 20.3627 29.6346 19.3994L28.8387 15.0217C28.7374 14.4682 28.4451 13.9678 28.0128 13.6077C27.5805 13.2475 27.0356 13.0505 26.4729 13.0508Z"
                                fill="#237276"
                              />
                              <path
                                d="M17.9923 13.1226H14.6317C14.4642 13.1226 14.3035 13.1891 14.185 13.3076C14.0666 13.4261 14 13.5867 14 13.7543V23.255C14 23.4226 14.0666 23.5832 14.185 23.7017C14.3035 23.8202 14.4642 23.8867 14.6317 23.8867H17.9923C18.1599 23.8867 18.3205 23.8202 18.439 23.7017C18.5575 23.5832 18.624 23.4226 18.624 23.255V13.7543C18.624 13.5867 18.5575 13.4261 18.439 13.3076C18.3205 13.1891 18.1599 13.1226 17.9923 13.1226ZM15.2634 14.386H17.3606V22.6233H15.2634V14.386Z"
                                fill="#237276"
                              />
                            </svg>
                          </span>
                          <span class="d-flex ga-1 flex-column">
                            <span class="f-s-16 c-dark f-w-600">100,000</span>
                            <span class="f-s-14 c-gray f-w-400"
                              >Videos Dislikes</span
                            >
                          </span>
                        </v-sheet>
                      </v-col>
                    </v-row>
                  </v-sheet>
                </v-col>
                <v-col cols="12">
                  <v-sheet class="pa-5 ma-2 border rounded-lg">
                    <div class="f-s-20 c-dark f-w-600">
                      Average daily results
                    </div>
                    <v-row>
                      <v-col cols="6" :lg="3">
                        <v-sheet class="pa-2 ma-2 d-flex align-center ga-3">
                          <span>
                            <svg
                              width="42"
                              height="43"
                              viewBox="0 0 42 43"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <ellipse
                                cx="20.7571"
                                cy="21.1088"
                                rx="20.7571"
                                ry="21.058"
                                fill="#DDECED"
                                fill-opacity="0.4"
                              />
                              <g clip-path="url(#clip0_5445_123153)">
                                <path
                                  d="M24.6875 28.1133H20.9318L24.8777 22.7977C25.6733 21.737 26.0938 20.4738 26.0938 19.1445C26.0938 15.7844 23.3601 13.0508 20 13.0508C16.6399 13.0508 13.9062 15.7844 13.9062 19.1445C13.9062 20.4738 14.3268 21.737 15.1209 22.7959L19.0683 28.1133H15.3125C15.0536 28.1133 14.8438 28.3232 14.8438 28.582C14.8438 28.8409 15.0536 29.0508 15.3125 29.0508H24.6875C24.9464 29.0508 25.1562 28.8409 25.1562 28.582C25.1562 28.3232 24.9464 28.1133 24.6875 28.1133ZM15.8723 22.2352C15.1994 21.3381 14.8438 20.2693 14.8438 19.1445C14.8438 16.3014 17.1568 13.9883 20 13.9883C22.8432 13.9883 25.1562 16.3014 25.1562 19.1445C25.1562 20.2693 24.8006 21.3381 24.1264 22.2371L20 27.7956L15.8723 22.2352Z"
                                  fill="#237276"
                                />
                                <path
                                  d="M20 14.9258C17.6738 14.9258 15.7812 16.8183 15.7812 19.1445C15.7812 21.4736 17.6774 23.3633 20 23.3633C22.3144 23.3633 24.2188 21.4821 24.2188 19.1445C24.2188 16.8183 22.3262 14.9258 20 14.9258ZM20 22.4258C19.3372 22.4258 18.7199 22.2281 18.2034 21.8888C18.4369 21.1098 19.166 20.5508 20 20.5508C20.834 20.5508 21.5631 21.1098 21.7966 21.8888C21.2801 22.2281 20.6628 22.4258 20 22.4258ZM19.0625 18.6758C19.0625 18.1588 19.4831 17.7383 20 17.7383C20.5169 17.7383 20.9375 18.1588 20.9375 18.6758C20.9375 19.1927 20.5169 19.6133 20 19.6133C19.4831 19.6133 19.0625 19.1927 19.0625 18.6758ZM22.5403 21.219C22.2963 20.7062 21.8948 20.2599 21.3601 19.9644C21.6788 19.6282 21.875 19.1746 21.875 18.6758C21.875 17.6419 21.0339 16.8008 20 16.8008C18.9661 16.8008 18.125 17.6419 18.125 18.6758C18.125 19.1746 18.3212 19.6282 18.6399 19.9644C18.1056 20.2597 17.7038 20.7058 17.4597 21.219C16.9968 20.6533 16.7188 19.9308 16.7188 19.1445C16.7188 17.3352 18.1907 15.8633 20 15.8633C21.8093 15.8633 23.2812 17.3352 23.2812 19.1445C23.2812 19.9308 23.0032 20.6533 22.5403 21.219Z"
                                  fill="#237276"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_5445_123153">
                                  <rect
                                    width="16"
                                    height="16"
                                    fill="white"
                                    transform="translate(12 13.0508)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </span>
                          <span class="d-flex ga-1 flex-column">
                            <span class="f-s-16 c-dark f-w-600">100,000</span>
                            <span class="f-s-14 c-gray f-w-400"
                              >Channel visits</span
                            >
                          </span>
                        </v-sheet>
                      </v-col>
                      <v-col cols="6" :lg="3">
                        <v-sheet class="pa-2 ma-2 d-flex align-center ga-3">
                          <span>
                            <svg
                              width="42"
                              height="43"
                              viewBox="0 0 42 43"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <ellipse
                                cx="21.0071"
                                cy="21.1088"
                                rx="20.7571"
                                ry="21.058"
                                fill="#DDECED"
                                fill-opacity="0.4"
                              />
                              <path
                                d="M10.5588 13.0508H29.7062H30.348V13.6926V29.409V30.0508H29.7062H10.5588H9.91699V29.409V13.6926V13.0508H10.5588ZM29.0644 14.3344H11.2006V28.7672H29.0644V14.3344Z"
                                fill="#237276"
                              />
                              <path
                                d="M10.5588 17.3789H29.7062H30.348V18.0207V29.4089V30.0507H29.7062H10.5588H9.91699V29.4089V18.0207V17.3789H10.5588ZM29.0644 18.6625H11.2006V28.7671H29.0644V18.6625Z"
                                fill="#237276"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M12.2686 15.2148H13.5522V16.4985H12.2686V15.2148Z"
                                fill="#237276"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M14.7324 15.2148H16.016V16.4985H14.7324V15.2148Z"
                                fill="#237276"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M17.1953 15.2148H18.4789V16.4985H17.1953V15.2148Z"
                                fill="#237276"
                              />
                              <path
                                d="M23.4805 23.7131C22.6712 22.7754 20.1861 20.5459 16.8726 23.7131C20.1861 26.8802 22.6712 24.6508 23.4805 23.7131ZM15.5048 23.2768C20.9008 17.4682 24.8095 23.3354 24.8209 23.3521L25.0675 23.7131L24.8209 24.0741C24.8095 24.0908 20.9007 29.9579 15.5048 24.1493L15.0996 23.7131L15.5048 23.2768Z"
                                fill="#237276"
                              />
                              <path
                                d="M20.1311 24.3578C20.4855 24.3578 20.7729 24.0705 20.7729 23.716C20.7729 23.3616 20.4855 23.0742 20.1311 23.0742C19.7766 23.0742 19.4893 23.3616 19.4893 23.716C19.4893 24.0705 19.7766 24.3578 20.1311 24.3578Z"
                                fill="#237276"
                              />
                            </svg>
                          </span>
                          <span class="d-flex ga-1 flex-column">
                            <span class="f-s-16 c-dark f-w-600">100,000</span>
                            <span class="f-s-14 c-gray f-w-400"
                              >Videos Views</span
                            >
                          </span>
                        </v-sheet>
                      </v-col>
                      <v-col cols="6" :lg="3">
                        <v-sheet class="pa-2 ma-2 d-flex align-center ga-3">
                          <span>
                            <svg
                              width="43"
                              height="43"
                              viewBox="0 0 43 43"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <ellipse
                                cx="21.2571"
                                cy="21.1088"
                                rx="20.7571"
                                ry="21.058"
                                fill="#DDECED"
                                fill-opacity="0.4"
                              />
                              <path
                                d="M25.9759 29.0508H20.4517C18.6229 29.0508 18.0259 28.637 17.0436 27.62C16.9814 27.5615 16.9317 27.4909 16.8975 27.4126C16.8633 27.3343 16.8454 27.2499 16.8447 27.1645C16.8441 27.079 16.8608 26.9944 16.8939 26.9156C16.9269 26.8368 16.9756 26.7655 17.0369 26.7061C17.0983 26.6466 17.1711 26.6003 17.2509 26.5698C17.3307 26.5393 17.4158 26.5253 17.5012 26.5286C17.5866 26.532 17.6704 26.5526 17.7475 26.5893C17.8247 26.6259 17.8936 26.6779 17.9501 26.7419C18.6861 27.5031 18.964 27.7874 20.4517 27.7874H25.9759C26.2446 27.7874 26.5047 27.6923 26.7099 27.5188C26.9152 27.3453 27.0523 27.1048 27.0971 26.8398L27.9278 22.2884C27.9547 22.1682 28.0162 22.0584 28.1047 21.9726C28.7364 21.3409 28.9417 20.6934 28.6985 20.1028C28.6101 19.8756 28.4613 19.6769 28.2681 19.5283C28.0749 19.3796 27.8447 19.2867 27.6025 19.2594H24.7598C24.6677 19.2606 24.5763 19.2416 24.4923 19.2038C24.4082 19.1659 24.3334 19.1101 24.2732 19.0403C24.213 18.9704 24.1689 18.8883 24.1438 18.7995C24.1187 18.7108 24.1134 18.6177 24.1282 18.5267C24.1282 18.5077 24.4187 16.7421 24.1282 15.624C23.9355 14.8502 23.6196 14.3606 23.3069 14.329C23.2162 14.3296 23.1269 14.352 23.0467 14.3943C22.9664 14.4366 22.8975 14.4977 22.8458 14.5722C22.8458 15.2829 22.8111 17.0296 21.3961 18.4446C19.981 19.8596 17.6753 20.1849 17.5838 20.1975C17.5008 20.2091 17.4164 20.2043 17.3353 20.1833C17.2542 20.1623 17.178 20.1255 17.1112 20.075C17.0443 20.0246 16.988 19.9615 16.9455 19.8893C16.9031 19.8171 16.8752 19.7372 16.8636 19.6543C16.852 19.5713 16.8568 19.4869 16.8779 19.4058C16.8989 19.3247 16.9357 19.2485 16.9861 19.1817C17.0365 19.1148 17.0997 19.0585 17.1719 19.0161C17.2441 18.9736 17.3239 18.9457 17.4069 18.9341C17.4448 18.9341 19.4346 18.6183 20.5243 17.5349C21.614 16.4515 21.6014 15.0902 21.6014 14.5059C21.6014 13.8363 22.3025 13.1604 23.0985 13.0625C23.5975 13.0025 24.8199 13.0941 25.3726 15.3019C25.5473 16.1837 25.5814 17.0877 25.4737 17.9803H27.6025C28.0941 18.0087 28.5676 18.1761 28.9679 18.4629C29.3682 18.7497 29.6789 19.1442 29.864 19.6006C30.2872 20.6208 30.0187 21.7389 29.1375 22.7022L28.3416 27.0799C28.2403 27.6333 27.948 28.1337 27.5158 28.4939C27.0835 28.854 26.5385 29.0511 25.9759 29.0508Z"
                                fill="#237276"
                              />
                              <path
                                d="M17.4953 28.979H14.1346C13.9671 28.979 13.8064 28.9124 13.6879 28.794C13.5695 28.6755 13.5029 28.5148 13.5029 28.3473V18.8465C13.5029 18.679 13.5695 18.5183 13.6879 18.3999C13.8064 18.2814 13.9671 18.2148 14.1346 18.2148H17.4953C17.6628 18.2148 17.8235 18.2814 17.9419 18.3999C18.0604 18.5183 18.127 18.679 18.127 18.8465V28.3473C18.127 28.5148 18.0604 28.6755 17.9419 28.794C17.8235 28.9124 17.6628 28.979 17.4953 28.979ZM14.7663 27.7156H16.8636V19.4782H14.7663V27.7156Z"
                                fill="#237276"
                              />
                            </svg>
                          </span>
                          <span class="d-flex ga-1 flex-column">
                            <span class="f-s-16 c-dark f-w-600">100,000</span>
                            <span class="f-s-14 c-gray f-w-400"
                              >Videos likes</span
                            >
                          </span>
                        </v-sheet>
                      </v-col>
                      <v-col cols="6" :lg="3">
                        <v-sheet class="pa-2 ma-2 d-flex align-center ga-3">
                          <span>
                            <svg
                              width="43"
                              height="43"
                              viewBox="0 0 43 43"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <ellipse
                                cx="21.5071"
                                cy="21.1088"
                                rx="20.7571"
                                ry="21.058"
                                fill="#DDECED"
                                fill-opacity="0.4"
                              />
                              <path
                                d="M26.4729 13.0508H20.9487C19.12 13.0508 18.523 13.4645 17.5407 14.4816C17.4785 14.5401 17.4288 14.6107 17.3946 14.6889C17.3604 14.7672 17.3424 14.8517 17.3418 14.9371C17.3412 15.0225 17.3579 15.1072 17.3909 15.186C17.424 15.2648 17.4726 15.336 17.534 15.3955C17.5954 15.4549 17.6681 15.5013 17.7479 15.5318C17.8277 15.5623 17.9129 15.5763 17.9983 15.573C18.0836 15.5696 18.1674 15.549 18.2446 15.5123C18.3218 15.4756 18.3907 15.4237 18.4472 15.3596C19.1831 14.5984 19.4611 14.3142 20.9487 14.3142H26.4729C26.7417 14.3142 27.0017 14.4093 27.207 14.5828C27.4122 14.7562 27.5494 14.9968 27.5942 15.2617L28.4249 19.8131C28.4518 19.9334 28.5133 20.0432 28.6018 20.129C29.2335 20.7607 29.4388 21.4082 29.1956 21.9988C29.1072 22.226 28.9583 22.4246 28.7652 22.5733C28.572 22.7219 28.3418 22.8149 28.0996 22.8421H25.2569C25.1647 22.8409 25.0734 22.8599 24.9893 22.8978C24.9053 22.9357 24.8305 22.9915 24.7703 23.0613C24.7101 23.1311 24.6659 23.2133 24.6409 23.302C24.6158 23.3907 24.6105 23.4839 24.6252 23.5749C24.6252 23.5938 24.9158 25.3594 24.6252 26.4775C24.4326 27.2514 24.1167 27.7409 23.804 27.7725C23.7133 27.772 23.624 27.7496 23.5437 27.7072C23.4635 27.6649 23.3946 27.6039 23.3429 27.5293C23.3429 26.8187 23.3081 25.072 21.8931 23.657C20.4781 22.242 18.1724 21.9167 18.0808 21.904C17.9979 21.8924 17.9134 21.8973 17.8323 21.9183C17.7513 21.9393 17.6751 21.9761 17.6082 22.0265C17.5414 22.077 17.4851 22.1401 17.4426 22.2123C17.4001 22.2845 17.3723 22.3643 17.3607 22.4473C17.3491 22.5303 17.3539 22.6147 17.3749 22.6958C17.3959 22.7769 17.4327 22.853 17.4832 22.9199C17.5336 22.9868 17.5967 23.043 17.6689 23.0855C17.7411 23.128 17.821 23.1558 17.9039 23.1674C17.9418 23.1674 19.9317 23.4833 21.0214 24.5667C22.1111 25.65 22.0984 27.0113 22.0984 27.5956C22.0984 28.2652 22.7996 28.9412 23.5956 29.0391C24.0946 29.0991 25.3169 29.0075 25.8697 26.7997C26.0443 25.9178 26.0784 25.0139 25.9707 24.1213H28.0996C28.5912 24.0928 29.0647 23.9255 29.465 23.6387C29.8653 23.3519 30.176 22.9574 30.361 22.501C30.7843 21.4808 30.5158 20.3627 29.6346 19.3994L28.8387 15.0217C28.7374 14.4682 28.4451 13.9678 28.0128 13.6077C27.5805 13.2475 27.0356 13.0505 26.4729 13.0508Z"
                                fill="#237276"
                              />
                              <path
                                d="M17.9923 13.1226H14.6317C14.4642 13.1226 14.3035 13.1891 14.185 13.3076C14.0666 13.4261 14 13.5867 14 13.7543V23.255C14 23.4226 14.0666 23.5832 14.185 23.7017C14.3035 23.8202 14.4642 23.8867 14.6317 23.8867H17.9923C18.1599 23.8867 18.3205 23.8202 18.439 23.7017C18.5575 23.5832 18.624 23.4226 18.624 23.255V13.7543C18.624 13.5867 18.5575 13.4261 18.439 13.3076C18.3205 13.1891 18.1599 13.1226 17.9923 13.1226ZM15.2634 14.386H17.3606V22.6233H15.2634V14.386Z"
                                fill="#237276"
                              />
                            </svg>
                          </span>
                          <span class="d-flex ga-1 flex-column">
                            <span class="f-s-16 c-dark f-w-600">100,000</span>
                            <span class="f-s-14 c-gray f-w-400"
                              >Videos Dislikes</span
                            >
                          </span>
                        </v-sheet>
                      </v-col>
                    </v-row>
                  </v-sheet>
                </v-col>
                <!-- chart  -->
                <v-col cols="12">
                  <v-sheet class="pa-5 ma-2 border rounded-lg">
                    <div
                      class="f-s-20 c-dark f-w-600 d-flex align-center justify-space-between"
                    >
                      <span>Follower growth</span>
                      <span class="d-flex align-center ga-2 dashboard-card">
                        <v-select
                          v-model="follower_growth"
                          :items="filter_days"
                          item-title="title"
                          item-value="value"
                        ></v-select>
                        <v-date-input
                          prepend-icon=""
                          v-model="follower_growth_from"
                          clearable
                          label="From"
                          variant="outlined"
                        ></v-date-input>
                        <v-date-input
                          prepend-icon=""
                          v-model="follower_growth_to"
                          clearable
                          label="To"
                          variant="outlined"
                        ></v-date-input>
                      </span>
                    </div>
                    <v-row>
                      <v-col cols="12">
                        <v-sheet
                          class="pa-2 ma-2 d-flex align-center ga-3"
                          style="height: 50vh"
                        >
                          <Line :data="chartData" :options="chartOptions" />
                        </v-sheet>
                      </v-col>
                    </v-row>
                  </v-sheet>
                </v-col>
                <v-col cols="12">
                  <v-sheet class="pa-5 ma-2 border rounded-lg">
                    <div
                      class="f-s-20 c-dark f-w-600 d-flex align-center justify-space-between"
                    >
                      <span>Day activity</span>
                      <span class="d-flex align-center ga-2 dashboard-card">
                        <v-date-input
                          v-model="day_activity_date"
                          clearable
                          label="From"
                          variant="outlined"
                          multiple
                        ></v-date-input>
                      </span>
                    </div>
                    <v-row>
                      <v-col cols="12">
                        <v-sheet class="pa-2 ma-2 d-flex align-center ga-3">
                          <VerticalBarChart
                            :height="'50vh'"
                            :chartData="data"
                            :chartOptions="options"
                          />
                        </v-sheet>
                      </v-col>
                    </v-row>
                  </v-sheet>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BreadCrumb from "@/components/layout/BreadCrumb.vue";
import GlobalNav from "@/components/layout/GlobalNav.vue";
import SideBar from "@/components/layout/SideBar.vue";
import { VDateInput } from "vuetify/labs/VDateInput";
import { Line } from "vue-chartjs";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import VerticalBarChart from "@/components/VerticalBarChart.vue";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default {
  name: "YouTubeInsights",
  props: {},
  components: {
    BreadCrumb,
    GlobalNav,
    SideBar,
    VDateInput,
    Line,
    VerticalBarChart,
  },

  data() {
    return {
      follower_growth_from: null,
      follower_growth_to: null,
      filter_days: [
        { title: "Last Day", value: "last_day" },
        { title: "Last Week", value: "last_week" },
        { title: "Last Month", value: "last_month" },
        { title: "Last Year", value: "last_year" },
      ],
      day_activity_date: null,
      chartData: {
        labels: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        datasets: [
          {
            label: "Followers",
            data: [
              10000, 20000, 15000, 25000, 30000, 40000, 10000, 20000, 15000,
              25000, 30000, 40000,
            ],
            borderColor: "#B0E5E8",
            backgroundColor: "#B0E5E8",
            pointBackgroundColor: "white",
            pointBorderColor: "black",
            pointBorderWidth: 5,
            pointRadius: 7,
            pointHoverRadius: 9,
            borderWidth: 2,
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: true,
            text: "Follower Growth Trends",
            font: { size: 18 },
          },
          legend: {
            position: "top",
          },
          tooltip: {
            enabled: true,
            callbacks: {
              label: (context) =>
                `${context.dataset.label}: ${context.parsed.y}`,
            },
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: "Months",
            },
            grid: {
              display: false,
            },
          },
          y: {
            title: {
              display: true,
              text: "Number of Followers",
            },
            beginAtZero: true,
            grid: {
              color: "rgba(0, 0, 0, 0.1)",
            },
          },
        },
      },
      data: {
        labels: [
          "10 Sept",
          "11 Sept",
          "12 Sept",
          "13 Sept",
          "14 Sept",
          "15 Sept",
          "16 Sept",
          "17 Sept",
        ], // Days
        datasets: [
          {
            label: "Likes",
            data: [30, 40, 50, 30, 40, 30, 45, 52], // Number of likes each day
            backgroundColor: "#E6E6E6",
            borderColor: "transparent",
            borderWidth: 1,
            borderRadius: 15,
          },
          {
            label: "Followers",
            data: [35, 45, 35, 45, 35, 30, 45, 52], // Number of followers each day
            backgroundColor: "#237276", // Different color for clarity
            borderColor: "transparent",
            borderWidth: 1,
            borderRadius: 15,
          },
          {
            label: "Comments",
            data: [50, 55, 50, 55, 50, 30, 45, 52], // Number of comments each day
            backgroundColor: "#61CBD1", // Different color for clarity
            borderColor: "transparent",
            borderWidth: 1,
            borderRadius: 15,
          },
        ],
      },
      options: {
        responsive: true,
        scales: {
          y: {
            beginAtZero: false,
          },
        },
      },
    };
  },
  watch: {},
  computed: {},

  methods: {},

  created() {},
  mounted() {},
};
</script>
<style scoped>
.c-dark {
  color: #0d0d0d;
}
.c-gray {
  color: #666666;
}
.f-w-600 {
  font-weight: 600;
}
.f-w-400 {
  font-weight: 400;
}
.f-s-20 {
  font-size: 20px;
}
.f-s-16 {
  font-size: 16px;
}
.f-s-14 {
  font-size: 14px;
}
</style>
